// extracted by mini-css-extract-plugin
export var button = "styles-module--button--sC00w";
export var secondary = "styles-module--secondary--gik6Y";